export default __webpack_public_path__ + "static/media/collection_Scandic.54888e4c.jpg";